module.exports = __webpack_public_path__ + "img/piano_ambito.72e29046.svg";